import { createReducer, on } from "@ngrx/store";
import { resetUser, setUser, updateSettings, updateUser } from "./auth.actions";
import { User } from "src/app/auth/model/user";

export interface AuthState {
  user: User | undefined;
}

export const initialState: AuthState = { user: undefined };

export const authReducer = createReducer(
  initialState,
  on(setUser, (state: AuthState, { user }: { user: User }) => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    }
    return {
      ...state,
      user,
    };
  }),
  on(updateUser, (state, { user }: { user: User }): any => {
    if (state.user) {
      const { name, surname } = user;
      const updatedUser = { ...state.user, name, surname };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return { ...state, user: updatedUser };
    }
    return state;
  }),
  on(updateSettings, (state: AuthState, { settings }: { settings: string }): any => {
    if (state.user) {
      const updatedUser = { ...state.user, settings };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return { ...state, user: updatedUser };
    }
    return state;
  }),
  on(resetUser, (_) => {
    localStorage.removeItem("user");
    return initialState;
  }),
);
